function flatten(items, parentId = null, depth = 0) {
    return items ? items.reduce((acc, item, index) => {
        return [
            ...acc,
            { ...item, parentId, depth, index },
            ...flatten(item.children, item.id, depth + 1),
        ];
    }, []) : [];
}
export function flattenTree(items) {
    const treeItems = items;
    return flatten(treeItems);
}
export function moveRoundInArray(array, from, to, numFromChildren, expandedRowKeys) {
    const newArray = array.slice();
    const numTargetChildren = expandedRowKeys.includes(array[to].rowKey) ? 0 : array[to].children ? array[to].children.length : 0;
    const targetWithChildrenIndex = +to + (from < to ? (+numTargetChildren - numFromChildren) : 0);
    const newTargetIndex = targetWithChildrenIndex < 0 ? (newArray.length + targetWithChildrenIndex) : targetWithChildrenIndex;
    newArray.splice(newTargetIndex, 0, ...newArray.splice(from, 1 + numFromChildren).map(round => ({
        ...round,
        dragLoading: true
    })));
    return newArray;
}
